import { Component, Input } from '@angular/core';
import { KeyResumenDePago } from 'src/app/pago/enums/KeyResumenDePago.enum';
import { Pago } from 'src/app/pago/models/Pago.model';

@Component({
  selector: 'app-resumen-pago',
  templateUrl: './resumen-pago.component.html',
  styleUrls: ['./resumen-pago.component.scss'],
})
export class ResumenPagoComponent {
  readonly KEY_VALOR = KeyResumenDePago.VALOR;
  @Input() referencia: string;
  @Input() resumenesDePago: Pago;
}
